/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} All_Translation_Jobs_StartedInputs */



/**
* | output |
* | --- |
* | "All {count} translation jobs started" |
*
* @param {All_Translation_Jobs_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const all_translation_jobs_started = /** @type {((inputs: All_Translation_Jobs_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Translation_Jobs_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Toutes les ${i?.count} tâches de traduction ont été démarrées`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Alle ${i?.count} Übersetzungsaufträge gestartet`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tutti i lavori di traduzione ${i?.count} sono iniziati`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Все заказы на перевод ${i?.count} начались`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se iniciaron todos los trabajos de traducción ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`所有 ${i?.count} 翻译任务均已开始`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`すべての${i?.count}翻訳ジョブが開始されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सभी ${i?.count} अनुवाद कार्य शुरू हो गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Todos os trabalhos de tradução ${i?.count} começaram`)
	return /** @type {LocalizedString} */ (`All ${i?.count} translation jobs started`)
});